module.exports = __webpack_public_path__ + "static/media/baixar.5f38e268.png";